import * as React from "react";
import * as ReactDOM from "react-dom";
import {ButtonConfig, default as InfoDialog} from "./InfoDialog";

interface DialogOptions {
    title?: string;
    description?: string;
    status?: string;
    image?: string;
    imageHeight?: number;
    primaryButtonConfig?: ButtonConfig;
    secondaryButtonConfig?: ButtonConfig;
}

/**
 * Open Info Dialog
 *
 * @param options: DialogOptions
 */
export function showDialog(options: DialogOptions) {

    let dialogContainer = document.createElement("div");

    ReactDOM.render(
        <InfoDialog
            title={options.title}
            status={options.status}
            imageUrl={options.image}
            imageHeight={options.imageHeight}
            primaryButtonConfig={options.primaryButtonConfig}
            secondaryButtonConfig={options.secondaryButtonConfig}>

            <div dangerouslySetInnerHTML={{__html: options.description}}></div>
        </InfoDialog>,
        dialogContainer
    );

    document.body.appendChild(dialogContainer);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/info-dialog/InfoDialogApi.tsx
 **/